import { render, staticRenderFns } from "./UserRowSimple.vue?vue&type=template&id=ff154a08&scoped=true&"
import script from "./UserRowSimple.vue?vue&type=script&lang=js&"
export * from "./UserRowSimple.vue?vue&type=script&lang=js&"
import style0 from "./UserRowSimple.vue?vue&type=style&index=0&id=ff154a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff154a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff154a08')) {
      api.createRecord('ff154a08', component.options)
    } else {
      api.reload('ff154a08', component.options)
    }
    module.hot.accept("./UserRowSimple.vue?vue&type=template&id=ff154a08&scoped=true&", function () {
      api.rerender('ff154a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/components/UserList/UserRowSimple.vue"
export default component.exports